export enum TestRunningMode {
  DRAFT_MODE = 'DRAFT',
  REGULAR_MODE = 'REGULAR'
}
